<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="8">
						<el-form-item label="学生" prop="dbColumn_sid">
							<el-input v-model="formParameter.dbColumn_sid" autocomplete="off" disabled>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
					<el-form-item label="评分" prop="score">
							<el-rate v-model="formParameter.score*1" :colors="colors" disabled>
							</el-rate>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="学习时间" prop="subtime">
							<el-date-picker v-model="formParameter.subtime" align="right" type="date" placeholder="选择日期"
								:picker-options="pickerOptions" >
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="16">
						<el-form-item label="标题" prop="title">
							<el-input v-model="formParameter.title" autocomplete="off" :disabled="disabled" ></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="学习时间" prop="subtime" >
							<el-date-picker v-model="formParameter.subtime" align="right" type="date" placeholder="选择日期"
								:picker-options="pickerOptions"
								format="yyyy-MM-dd"   value-format="yyyy-MM-dd"
								disabled>
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="总结内容" prop="content">
							<wang-edit  v-model="formParameter.content" :isupdt="wangEditisupdt" >
							</wang-edit>
						</el-form-item>
					</el-col>
				</el-row>

			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">关 闭</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/study/feedback/feedback.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import wangEdit from '@/components/wangEdit/wangEdit.vue';

export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
		wangEdit
	},
	data() {
		return {
			colors: { 3: '#99A9BF', 5: '#FF9900' },
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
				shortcuts: [{
					text: '今天',
					onClick(picker) {
						picker.$emit('pick', new Date());
					}
				}, {
					text: '昨天',
					onClick(picker) {
						const date = new Date();
						date.setTime(date.getTime() - 3600 * 1000 * 24);
						picker.$emit('pick', date);
					}
				}, {
					text: '一周前',
					onClick(picker) {
						const date = new Date();
						date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', date);
					}
				}]
			},
			colors: { 3: '#99A9BF', 5: '#FF9900' },
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			formParameter: {},
			reflash:true,

			wangEditisupdt:false,

			rules: {
			       
				//学生提交时间
				subtime: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//老师查看时间
				chetime: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//标题
				title: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
			}
		};
	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {
	        //发请求加载正文
			//api.oneContent({id:parameter.id},res=>{
			    this.wangEditisupdt = true
			    this.formParameter = parameter;
				//加载正文
			//	this.formParameter.content = res.msg
			    this.disabled = disabled;
			    this.$refs.popup.open(title, size);

			    setTimeout(()=>{
				this.wangEditisupdt = false
			    },100)
			//})
		
			
		},
		//关闭弹框
		close() {
			this.disabled=true
			this.formParameter={}
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				 
					//编辑
					let parameter = {id:this.formParameter.id ,title:this.formParameter.title,
						             subtime:this.formParameter.subtime,content:this.formParameter.content}  ;
					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;

							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
			});
		}  
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';

/deep/.w-e-text-container{
        height: 450px !important;/*!important是重点，因为原div是行内样式设置的高度300px*/
    }

</style>
